import {
  LocalDevicePresencePayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createLocalDevicePresenceMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: LocalDevicePresencePayload) => {
    try {
      // A device going offline is a field change on a row that still exists, so
      // the backend only ever sends MODIFY and the truth is `item.isConnected`.
      if (action !== WebSocketAction.MODIFY) {
        log.debug(
          '[LocalDevicePresenceHandler] Ignoring action for LocalDevicePresence:',
          action,
        );
        return;
      }

      log.debug(
        `[LocalDevicePresenceHandler] MODIFY ${item.deviceId} isConnected=${item.isConnected}`,
      );
      eventEmitter.emit(
        WebSocketEntityType.LocalDevicePresence,
        WebSocketEventType.MODIFY,
        item,
      );
    } catch (error) {
      log.error('[LocalDevicePresenceHandler] Handler failed:', error);
    }
  };
}
